import React, { useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import NavigationIcon from './NavigationIcon';
import Text from './Text';
import PropTypes from 'prop-types';
import Link from 'next/link';
import Tooltip from 'molecules/ToolTip';

const TOOLTIP_OFFSET_PX = 16;

const Tab = ({
  iconKey,
  listItemClass = '',
  listName,
  href = '',
  active = false,
  disabled = false,
  toolTip,
  toolTipText,
}) => {
  const triggerRef = useRef(null);
  const [tooltipPosition, setTooltipPosition] = useState(null);

  const showTooltip = () => {
    if (!toolTip || !triggerRef.current) return;
    const rect = triggerRef.current.getBoundingClientRect();
    setTooltipPosition({ top: rect.top + rect.height / 2, left: rect.right + TOOLTIP_OFFSET_PX });
  };
  const hideTooltip = () => setTooltipPosition(null);

  return (
    <>
      <Link href={disabled ? {} : href}>
        <li
          ref={triggerRef}
          onMouseEnter={showTooltip}
          onMouseLeave={hideTooltip}
          className={`px-3 py-1 xl:px-4 xl:py-1.5 ${
            active && 'bg-primary-900 bg-opacity-10'
          } flex items-center group relative rounded gap-x-2 transition-all ease-in-out duration-200 ${
            disabled ? 'cursor-default' : 'cursor-pointer hover:bg-[#1756841a]'
          } ${listItemClass}`}
        >
          <span className="relative flex items-center gap-x-2.5">
            <NavigationIcon
              iconKey={iconKey}
              isActive={active}
              disabled={disabled}
              size={16}
              className="w-[14px] h-[14px] xl:w-4 xl:h-4 2xl:w-6 2xl:h-6"
            />
            <Text
              variant="bodySmall"
              fontWeight={active ? "font-medium" : "font-normal"}
              textColor={
                disabled
                  ? "text-secondary-100"
                  : active
                  ? "text-primary-900"
                  : "text-darkGrey-400"
              }
              className={`pt-0.5 ${!disabled && "group-hover:text-primary-900"}`}
            >
              {listName}
            </Text>
          </span>
        </li>
      </Link>
      {toolTip && tooltipPosition &&
        createPortal(
          <div
            className="fixed z-[100] -translate-y-1/2"
            style={{ top: tooltipPosition.top, left: tooltipPosition.left }}
          >
            <Tooltip
              content={toolTipText}
              tooltipClass="whitespace-nowrap"
              classForArrowIcon="absolute -left-1.5 top-1/2 -translate-y-1/2"
            />
          </div>,
          document.body
        )}
    </>
  );
};

Tab.propTypes = {
  iconKey: PropTypes.string,
  listItemClass: PropTypes.string,
  listName: PropTypes.string,
  active: PropTypes.bool,
  disabled: PropTypes.bool,
  toolTip: PropTypes.bool,
  toolTipText: PropTypes.string,
};
export default Tab;
